<template>
  <div id="login" class="login bg">
    <div class="limiter">
      <div class="container-login100">
        <div class="wrap-login100">
          <span class="login100-form-title p-b-26">船舶智能安防管理平台</span>
          <span class="login100-form-title p-b-48">
            <i class="fa fa-video-camera"></i>
          </span>

          <div class="wrap-input100 validate-input" data-validate="Valid email is: a@b.c">
            <input v-model="username" :class="'input100 ' + (username == '' ? '' : 'has-val')" type="text" name="username" />
            <span class="focus-input100" data-placeholder="用户名"></span>
          </div>

          <div class="wrap-input100 validate-input" data-validate="Enter password">
            <span class="btn-show-pass">
              <i :class="'fa ' + (!showPassword ? 'fa-eye' : 'fa-eye-slash')" @click="showPassword = !showPassword"></i>
            </span>
            <input
              v-model="password"
              :class="'input100 ' + (password == '' ? '' : 'has-val')"
              :type="!showPassword ? 'password' : 'text'"
              name="password"
            />
            <span class="focus-input100" data-placeholder="密码"></span>
          </div>

          <div class="container-login100-form-btn">
            <div
              v-loading="isLoging"
              class="wrap-login100-form-btn"
              :class="{ 'login-loading': isLoging }"
              element-loading-background="rgb(0 0 0 / 0%);"
              element-loading-custom-class="login-loading-class"
            >
              <div class="login100-form-bgbtn"></div>
              <button class="login100-form-btn" @click="login">登录</button>
            </div>
          </div>
        </div>

        <div class="el-login-footer">
          Copyright © 2022-2025 lhmovie All Rights Reserved.Version1.0.0
          <div class="footer">
            <el-button type="text" @click="copyText('50010202001388', '备案号', 'https://beian.mps.gov.cn/#/query/webSearch?code=50010202001388')">
              <img alt="图片加载失败" src="../assets/gov.png" />
              &ensp;渝公网安备50010202001388
            </el-button>
            <el-button type="text" @click="copyText('渝ICP备2022006452号-2', '备案号', 'http://beian.miit.gov.cn/')">
              渝ICP备2022006452号-2
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import crypto from "crypto"
import { Message } from "element-ui"
export default {
  name: "Login",
  data() {
    return {
      isLoging: false,
      showPassword: false,
      loginLoading: false,
      username: "",
      password: "",
    }
  },
  created() {
    var that = this
    window.addEventListener("message", (event) => {
      if (event.data.type == "login" && event.data.username) {
        this.username = event.data.username
        this.password = event.data.password
        sessionStorage.setItem("outSizeLogin", event.data.outSizeLogin)
        sessionStorage.setItem("shipName", event.data.shipName)
        that.login()
      }
    })
    document.onkeydown = function (e) {
      var key = window.event.keyCode
      if (key == 13) {
        that.login()
      }
    }
  },
  methods: {
    //登录逻辑
    login() {
      if (this.username != "" && this.password != "") {
        this.toLogin()
      }
    },

    //登录请求
    toLogin() {
      //一般要跟后端了解密码的加密规则
      //这里例子用的哈希算法来自./js/sha1.min.js

      //需要想后端发送的登录参数
      let loginParam = {
        username: this.username,
        password: crypto.createHash("md5").update(this.password, "utf8").digest("hex"),
      }
      var that = this
      //设置在登录状态
      this.isLoging = true

      this.$axios({
        method: "post",
        url: "/api/user/login",
        data: loginParam,
      })
        .then(function (res) {
          if (res.data.code == 200 && res.data.msg == "登陆成功") {
            sessionStorage.setItem("username", res.data.data.user.username)
            sessionStorage.setItem("userRole", JSON.stringify(res.data.data.user.role))
            sessionStorage.setItem("userCompany", JSON.stringify(res.data.data.user.company))
            sessionStorage.setItem("token", res.data.data.token)
            //登录成功后
            that.cancelEnterkeyDefaultAction()
            that.$router.push("/")
          } else {
            that.isLoging = false
            that.$message({
              showClose: true,
              message: "登录失败，用户名或密码错误",
              type: "error",
            })
          }
        })
        .catch(function (error) {
          that.$message.error(error.response.data.msg)
          that.isLoging = false
        })
    },
    setCookie: function (cname, cvalue, exdays) {
      var d = new Date()
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
      var expires = "expires=" + d.toUTCString()
      console.info(cname + "=" + cvalue + "; " + expires)
      document.cookie = cname + "=" + cvalue + "; " + expires
      console.info(document.cookie)
    },
    cancelEnterkeyDefaultAction: function () {
      document.onkeydown = function (e) {
        var key = window.event.keyCode
        if (key == 13) {
          return false
        }
      }
    },
    //复制文本
    copyText: (text, msg, url) => {
      navigator.clipboard.writeText(text).then(
        () => {
          Message({
            showClose: true,
            message: msg + "已复制到剪贴板",
            type: "success",
          })
          if (url !== undefined)
            setTimeout(() => {
              window.open(url)
            }, 1500)
        },
        () => {
          Message({
            showClose: true,
            message: msg + "复制失败,请自行复制以下内容：" + text,
            type: "warning",
          })
          if (url !== undefined)
            setTimeout(() => {
              window.open(url)
            }, 1500)
        }
      )
    },
  },
}
</script>
<style>
.bg {
  background: url(../assets/bgImg.jpg) no-repeat center;
  background-position: center;
  background-size: cover;
}
.el-login-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  color: #fff;
  font-family: Arial;
  font-size: 12px;
  letter-spacing: 1px;

  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 0;
    .el-button {
      padding: 0;
      img {
        width: 15px;
      }
      span {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue